module.exports = __webpack_public_path__ + "img/prodotti_mercati.223c81b8.svg";